import React from "react";
import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import ChargeManagementEditViewModel from "../../../viewModels/chargeManagement/chargeManagementEdit/chargeManagementEditViewModel";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";

const ChargeRefund: ViewComponent<ChargeManagementEditViewModel> = observer(({ vm }) => (
  <AlertWithInfoIcon variant="danger">
    <span>{vm.refundMessage}</span>
  </AlertWithInfoIcon>
));

export default ChargeRefund;
